import successNotification from "../../Notification/successNotification";
import errorNotification from "../../Notification/errorNotification";
import { postmortemApiEndpoint } from "../../../config";
import axios from "axios";
import { fetchToken } from "../../../services/fetchTokenService";
import { getConsumerKey } from "../../../services/maerskApiTokenService";
import { queryClient } from "../../../Utils/queryClient";

export const sendCollaborators = async (collaborators, instance, loginRequest, accounts, postmortemTeamId) => {
  const apiEndpoint = postmortemApiEndpoint;
  const url = `${apiEndpoint}/team/${postmortemTeamId}`;
  
  console.log('[SEND_COLLABORATORS] Sending collaborators to backend:', {
    teamId: postmortemTeamId,
    count: collaborators?.length || 0,
    emails: collaborators?.map(c => c.email) || [],
    url
  });
  
  try {
    // Get auth token
    const tokenResponse = await fetchToken(instance, loginRequest, accounts);
    
    const config = {
      headers: {
        Authorization: `Bearer ${tokenResponse.idToken}`,
        "consumer-key": getConsumerKey(),
      },
    };
    
    // Make PUT request
    const response = await axios.put(url, collaborators, config);
    queryClient.invalidateQueries(["teams"]);
    
    if (response.status === 200 || response.status === 201) {
      console.log('[SEND_COLLABORATORS] ✓ Successfully saved collaborators to backend');
      successNotification("Collaborators Updated Successfully");
      return response;
    } else {
      console.log("[SEND_COLLABORATORS] ✗ Unknown error - unexpected status:", response.status);
      console.error(response);
    }
  } catch (error) {
    if (error.response) {
      console.error('[SEND_COLLABORATORS] ✗ Backend error:', {
        status: error.response.status,
        data: error.response.data,
        teamId: postmortemTeamId
      });
      if (error.response.status === 500) {
        errorNotification("Error in saving collaborators");
      } else {
        errorNotification(`Error: ${error.response.status}`);
      }
    } else {
      console.log("[SEND_COLLABORATORS] ✗ Unknown network error");
      console.error(error);
      errorNotification("Error in saving collaborators");
    }
    throw error;
  }
};